import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../data/site";

/**
 * A slim, dark, always-in-motion scrolling wall of testimonials.
 * Sits directly under the hero on the Home page so corporate leads
 * see peer trust proof before they even scroll.
 */
export default function TestimonialsMarquee() {
  // Duplicate the array so the CSS `translateX(-50%)` loop is seamless.
  const items = [...TESTIMONIALS, ...TESTIMONIALS];

  return (
    <section
      data-testid="home-testimonials-marquee"
      aria-label="Client and peer testimonials"
      className="bg-brand-blue-deep text-white py-10 lg:py-12 border-y border-white/10 relative overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 mb-6 flex items-baseline justify-between gap-6">
        <div className="text-[10px] uppercase tracking-[0.28em] font-semibold text-brand-yellow">
          Trusted by peers and project leaders
        </div>
        <div className="text-[10px] uppercase tracking-[0.28em] font-semibold text-white/40 hidden sm:block">
          Hover to pause
        </div>
      </div>
      <div className="marquee-mask">
        <div className="marquee-track">
          {items.map((t, i) => (
            <figure
              key={`${t.name}-${i}`}
              data-testid={`marquee-item-${i}`}
              className="flex-shrink-0 w-[380px] md:w-[440px] mx-4 bg-white/[0.04] border border-white/10 backdrop-blur-sm p-6 lg:p-7 flex flex-col hover:border-brand-orange/60 transition-colors"
            >
              <Quote className="w-5 h-5 text-brand-orange mb-4 flex-shrink-0" strokeWidth={1.5} />
              <blockquote className="text-[15px] leading-relaxed text-white/90 mb-5 line-clamp-5 flex-1">
                {t.quote}
              </blockquote>
              <figcaption className="border-t border-white/15 pt-3">
                <div className="font-semibold text-white text-sm">{t.name}</div>
                <div className="text-[10px] uppercase tracking-[0.22em] text-white/60 mt-1">{t.title}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
